@if (isFinancingEnabled) {
<p class="filter-range-title" [class.is-loading]="isLoading | async">
    <span>{{
        minValueFinancingSelected || minValueFinancing
            | rasCurrency : {} : false : true
    }}</span>
    -
    <span>
        {{
            (maxValueFinancingSelected || maxValueFinancing) * 1
                | rasCurrency : {} : false : true
        }}
        @if (maxValueFinancingSelected === configuration.financingMaxValue) {
            <i>+</i>
        }
    </span>
</p>

<ras-filter-range-slider
    [selectedMax]="maxValueFinancingSelected"
    [selectedMin]="minValueFinancingSelected"
    [max]="maxValueFinancing"
    [min]="minValueFinancing"
    [isCurrency]="true"
    [increment]="configuration.financingIncrement"
    (rangeChange)="onChangeFinancing($event)"
>
</ras-filter-range-slider>

<mat-checkbox
    color="primary"
    [(ngModel)]="isFinancing"
    (ngModelChange)="onChangeFinancingToggle($event)"
>
    Financing Available
</mat-checkbox>
}
